var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.creatorGallery.secret)?_c('div',[_c('font-awesome-icon',{staticClass:"branded",attrs:{"icon":"fa-duotone fa-face-shush"}}),_vm._v(" "+_vm._s(_vm.$t("Secret"))+" ")],1):_c('div',[_c('font-awesome-icon',{staticClass:"text-primary",attrs:{"icon":"fa-duotone fa-globe"}}),_vm._v(" "+_vm._s(_vm.$t("Public"))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }